import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL } from 'config/env.config'

const FETCH_LIST_API_ID = 'EMPLOYEE/FETCH_PROGRAMS_API'

const apiCall = enhancedMakeFetchAction(
  FETCH_LIST_API_ID,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/flex/employee/v1/employees/${id}/employee-programs`,
      params
    }),
    method: 'GET'
  })
)

export default apiCall
